import axios from 'axios';
import type { SearchParam } from '../pages/WorkingBudgetList';
import { camelCase } from 'lodash';

export const getEstimatesSelectModal = () => {
  return axios
    .get('/api/v1/get/estimates/select-modal', {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
// 実行予算一覧を取得
export const getWorkingBudgetList = (
  searchParam: SearchParam,
  currentPage: number,
  displayLimit: number
) => {
  return axios
    .get('/api/v1/working_budget/list', {
      params: {
        construct_name: searchParam.estimateName,
        sales_user_id: searchParam.salesUserId,
        construct_code: searchParam.constructCode,
        estimate_total_from: searchParam.estimateTotalStart,
        estimate_total_end: searchParam.estimateTotalEnd,
        estimate_cost_total_from: searchParam.estimateCostTotalStart,
        estimate_cost_total_end: searchParam.estimateCostTotalEnd,
        additional_cost_from: searchParam.additionalCostStart,
        additional_cost_end: searchParam.additionalCostEnd,
        final_gross_profit_from: searchParam.finalGrossProfitStart,
        final_gross_profit_end: searchParam.finalGrossProfitEnd,
        final_gross_profit_margin_from: searchParam.finalGrossProfitMarginStart,
        final_gross_profit_margin_end: searchParam.finalGrossProfitMarginEnd,
        order_total_from: searchParam.orderTotalStart,
        order_total_end: searchParam.orderTotalEnd,
        page: currentPage,
        display_limit: displayLimit
      },
      headers: {
        withCredential: true
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 実行予算単一削除
export const deleteWorkingBudget = (workingBudgetId: number) => {
  return axios
    .delete(`/api/v1/working_budget/${workingBudgetId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
// 実行予算選択削除
export const deleteSelectedWorkingBudget = (working_budgets_list: number[]) => {
  return axios
    .post('/api/v1/delete/selected/working_budget', {
      working_budgets_list,
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
